import DeleteIcon from '@mui/icons-material/Delete';
import { Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FieldDataType } from '../../../../../sic-lib/enums/FieldDataType';
import { ConversationGridFiltersActions } from '../../../../../sic-lib/reducers/conversationGridFiltersReducer';
import { ConversationGridFiltersItem } from '../../../../../sic-lib/types/ConversationGridFiltersItem';
import { IErrorFormValidation } from '../../../../../sic-lib/utils/formValidationHelpers';
import { hasMatchingFieldDataType } from '../../../../../sic-lib/utils/functionalFilters';
import FilterFastField from '../FilterFastField/FilterFastField';
import FilterFastFieldDate from '../FilterFastFieldDate/FilterFastFieldDate';
import FilterFastFieldSelect from '../FilterFastFieldSelect/FilterFastFieldSelect';
import SelectFilterOperand from '../SelectFilterOperand/SelectFilterOperand';

const useStyles = makeStyles()((theme: Theme) => ({
    button: {
        [theme.breakpoints.down('md')]: {
            padding: '3px',
        },
    },
}));

type Props = {
    config: ConversationGridFiltersItem;
    formDispatch: React.Dispatch<ConversationGridFiltersActions>;
    formError: IErrorFormValidation | null;
};

export default function ConversationGridFiltersListItem({
    config,
    formDispatch,
    formError,
}: Props) {
    const { classes } = useStyles();
    // const { contactId } = useParams<{ contactId: string }>();

    const [isDateField, setIsDateField] = React.useState<boolean>(false);

    React.useEffect(() => {
        setIsDateField(hasMatchingFieldDataType(FieldDataType.date)(config));
    }, [config.fieldType]);

    const handleRemove = () => {
        formDispatch({
            type: 'REMOVE_FORM_FILTER',
            fieldId: config.fieldId,
        });
    };

    return (
        <Stack spacing={1.5}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="subtitle2" component="p">
                    {config.fieldName}
                </Typography>
                <Tooltip title="Remove">
                    <IconButton onClick={handleRemove} className={classes.button} size="large">
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
            <SelectFilterOperand
                fieldId={config.fieldId}
                fieldType={config.fieldType}
                operand={config.operand}
                formDispatch={formDispatch}
            />
            {!isDateField ? (
                config.isMultiselect ? (
                    <FilterFastFieldSelect
                        config={config}
                        formDispatch={formDispatch}
                        formError={formError}
                    />
                ) : (
                    <FilterFastField
                        fieldId={config.fieldId}
                        fieldType={config.fieldType}
                        fieldName="value"
                        fieldValue={config.value}
                        operand={config.operand}
                        formDispatch={formDispatch}
                        error={Boolean(
                            formError &&
                                formError.fieldId === config.fieldId &&
                                formError.field === 'value',
                        )}
                        helperText={
                            formError &&
                            formError.fieldId === config.fieldId &&
                            formError.field === 'value'
                                ? formError.message
                                : ''
                        }
                    />
                )
            ) : (
                <FilterFastFieldDate
                    fieldId={config.fieldId}
                    fieldType={config.fieldType}
                    fieldName="value"
                    fieldValue={config.value as string}
                    operand={config.operand}
                    formDispatch={formDispatch}
                    error={Boolean(
                        formError &&
                            formError.fieldId === config.fieldId &&
                            formError.field === 'value',
                    )}
                    helperText={
                        formError &&
                        formError.fieldId === config.fieldId &&
                        formError.field === 'value'
                            ? formError.message
                            : ''
                    }
                />
            )}
            {config.operand === 'between' && (
                <>
                    {!isDateField ? (
                        <FilterFastField
                            fieldId={config.fieldId}
                            fieldType={config.fieldType}
                            fieldName="value2"
                            fieldValue={config.value2}
                            operand={config.operand}
                            formDispatch={formDispatch}
                            error={Boolean(
                                formError &&
                                    formError.fieldId === config.fieldId &&
                                    formError.field === 'value2',
                            )}
                            helperText={
                                formError &&
                                formError.fieldId === config.fieldId &&
                                formError.field === 'value2'
                                    ? formError.message
                                    : ''
                            }
                        />
                    ) : (
                        <FilterFastFieldDate
                            fieldId={config.fieldId}
                            fieldType={config.fieldType}
                            fieldName="value2"
                            fieldValue={config.value2 as string}
                            operand={config.operand}
                            formDispatch={formDispatch}
                            error={Boolean(
                                formError &&
                                    formError.fieldId === config.fieldId &&
                                    formError.field === 'value2',
                            )}
                            helperText={
                                formError &&
                                formError.fieldId === config.fieldId &&
                                formError.field === 'value2'
                                    ? formError.message
                                    : ''
                            }
                        />
                    )}
                </>
            )}
        </Stack>
    );
}
